import { pick } from 'lodash'
import { createSelector } from 'reselect'

export const selectAppointmentPriceRulesById = (state) =>
  state.resources.AppointmentPriceRulesReducer.byId
export const selectAppointmentPriceRuleIds = (state) =>
  state.resources.AppointmentPriceRulesReducer.allIds

export const selectAllAppointmentPriceRules = createSelector(
  [selectAppointmentPriceRuleIds, selectAppointmentPriceRulesById],
  (allIds, byId) => allIds.map((id) => byId[id]).filter((v) => typeof v !== 'undefined')
)

export const selectAppointmentPriceRule = (typeId) =>
  createSelector([selectAppointmentPriceRulesById], (byId = {}) => byId[typeId])

export const selectAppointmentPriceRules = (ids) =>
  createSelector([selectAppointmentPriceRulesById], (byId = {}) => Object.values(pick(byId, ids)))

export const selectAppointmentPriceRuleById = selectAppointmentPriceRule
